__turbopack_context__.v({
  "button-group": "TabContent-module-scss-module__p_LJAq__button-group",
  "enable-button": "TabContent-module-scss-module__p_LJAq__enable-button",
  "fade-button": "TabContent-module-scss-module__p_LJAq__fade-button",
  "group-options": "TabContent-module-scss-module__p_LJAq__group-options",
});
